import { Col, Container, Row } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll";
import { Parallax } from "react-scroll-parallax";

const Product = () => {
    return(
        <Container className="relative">
            <div className="product p-5">
                <Parallax speed={-20} className="video-parallax-2"/>
                <Parallax speed={10} className="video-parallax-3"/>
                <ScrollAnimation animateIn='bounce' animateOnce={true} className="text-center">
                    <strong className="text-brand">PRODUK KAMI</strong>
                </ScrollAnimation>
                <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
                    <div className="header mt-4 text-black text-center">Teknologi Dibalik TEMA</div>
                    <p className="text-center mt-4">Seluruh proses monitoring, pencatatan absensi, hingga penjadwalan harian dapat diakses dalam satu platform digital yang saling terhubung.</p>
                </ScrollAnimation>
                <div className="text-center mt-5 video-wrapper">
                    <video autoPlay muted loop>
                        <source src={require("../assets/video/video.mp4")} type="video/mp4" />
                    </video>
                </div>
            </div>
        </Container>
    )
}

export default Product